module.exports = __webpack_public_path__ + "img/HD.cd69e2dd.png";